<template>
<div>
</div>
</template>

<script>
export default {
  name: "page-royaumes"
}
</script>

<style scoped>

</style>